export let converts_to = [
  "metal",
  "glass",
  "debris",
  "fabric",
  "vinyl",
  "wood",
  "resin",
  "epoxy",
  "plastic",
  "rubber",
];

export let converts_from = [
  "metal",
  "plastic",
  "sheets",
  "wood",
  "boards",
  "resin",
  "epoxy",
  "paint",
  "rubber",
];

export let ingredients = [
  "metal",
  "glass",
  "canvas",
  "wood",
  "fabric",
  "steel",
  "rubber",
  "aluminum",
  "vinyl",
  "acrylic",
  "resin",
  "epoxy",
];

export let tags = [
  "recycle",
  "industrial",
  "reuse",
  "home",
  "office",
  "tools",
  "electronics",
  "electric",
  "digital",
  "plastic",
  "omputers",
  "instruments",
  "packaging",
  "technology",
  "network",
  "wires",
];

export let boardData = {
  "name": "New Board",
  "id": "2947296089",
  "items": [
    {
      "name": "Chairs",
      "id": "2947296123",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": "Working on it"
        },
        {
          "title": "Last Use Date",
          "text": "2022-07-19"
        },
        {
          "title": "Quantity",
          "text": "20"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "wood, steel"
        }
      ]
    },
    {
      "name": "Desk",
      "id": "2947296133",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": "Done"
        },
        {
          "title": "Last Use Date",
          "text": "2022-07-12"
        },
        {
          "title": "Quantity",
          "text": "12"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "wood, plastic, boards"
        }
      ]
    },
    {
      "name": "Cabinet",
      "id": "2947296142",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": "2022-07-14"
        },
        {
          "title": "Quantity",
          "text": "8"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "canvas, plastic, storage"
        }
      ]
    },
    {
      "name": "Paper",
      "id": "2973623318",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "600"
        },
        {
          "title": "Units",
          "text": "sheets"
        },
        {
          "title": "Materials",
          "text": "paper, cardboard"
        }
      ]
    },
    {
      "name": "Computer Monitor",
      "id": "2973623523",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "16"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "plastic, electronic, screen"
        }
      ]
    },
    {
      "name": "Keyoard",
      "id": "2973623821",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "10"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "plastic, electronic, input, wires, keys"
        }
      ]
    },
    {
      "name": "Mouse",
      "id": "2973624649",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "10"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "plastic, electronic, battery, input, click"
        }
      ]
    },
    {
      "name": "Cups",
      "id": "2973624896",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "80"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "plastic, liquid"
        }
      ]
    }
  ]
};

export let fb_items = [
  {
    name: "Chairs",
    converts_to: ["wood", "plastic", "rubber", "vinyl"],
    poss_converts_to: ["fiber-board", "steel", "leather"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2947296123_v_0",
    pixiData: {
      position: {
        x: 400,
        y: 100,
      },
    },
    id: "2947296123",
    item_id: "2947296123",
    column_values: [
      {
        text: "2022-09-30",
        title: "Last Use Date",
      },
      {
        text: "20",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "wood, steel",
        title: "Salvage",
      },
      {
        text: "Steel case karman plastic chairs",
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587402636/chair.jpeg",
        title: "Photos",
      },
    ],
    ndId: "2947296123",
    ndType: "board_item",
  },
  {
    name: "Desk",
    converts_to: ["wood", "rubber", "planks"],
    poss_converts_to: ["wood", "plastic", "boards", "board"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2947296133_v_0",
    pixiData: {
      position: {
        x: 300,
        y: 300,
      },
    },
    id: "2947296133",
    item_id: "2947296133",
    column_values: [
      {
        text: "2022-09-30",
        title: "Last Use Date",
      },
      {
        text: "12",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "wood, plastic, boards",
        title: "Salvage",
      },
      {
        text: '48" x 24" wooden desks',
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587402655/desk.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Cabinet",
    converts_to: ["vinyl", "steel"],
    poss_converts_to: ["canvas", "plastic"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2947296142_v_0",
    pixiData: {
      position: {
        x: 200,
        y: 500,
      },
    },
    id: "2947296142",
    item_id: "2947296142",
    column_values: [
      {
        text: "2022-09-30",
        title: "Last Use Date",
      },
      {
        text: "8",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "canvas, plastic",
        title: "Salvage",
      },
      {
        text: "5 Drawer Mobile File Cabinet",
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587402925/cabinets.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Paper",
    converts_to: ["paper"],
    poss_converts_to: ["paper", "cardboard"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973623318_v_0",
    pixiData: {
      position: {
        x: 400,
        y: 700,
      },
    },
    id: "2973623318",
    item_id: "2973623318",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "600",
        title: "Quantity",
      },
      {
        text: "sheets",
        title: "Units",
      },
      {
        text: "paper, cardboard",
        title: "Salvage",
      },
      {
        text: "A4 sized used and unused",
        title: "Description",
      },
      {
        text: "",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Computer Monitor",
    converts_to: ["plastic", "electronic"],
    poss_converts_to: ["plastic", "electronic", "screen"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973623523_v_0",
    pixiData: {
      position: {
        x: 600,
        y: 500,
      },
    },
    id: "2973623523",
    item_id: "2973623523",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "16",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "plastic, electronic, screen",
        title: "Salvage",
      },
      {
        text: '27" LCD Screens',
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587403221/computer-monitor.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Keyoard",
    converts_to: ["electronic", "wire"],
    poss_converts_to: ["plastic", "electronic", "wires", "wire", "keys", "key"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973623821_v_0",
    pixiData: {
      position: {
        x: 500,
        y: 400,
      },
    },
    id: "2973623821",
    item_id: "2973623821",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "10",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "plastic, electronic, wires, keys",
        title: "Salvage",
      },
      {
        text: "Logitech K270 Wireless Keyboard (Blue)",
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587403212/computer-keyboard.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Mouse",
    converts_to: ["electronic", "wire"],
    poss_converts_to: ["plastic", "electronic", "battery"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973624649_v_0",
    pixiData: {
      position: {
        x: 600,
        y: 700,
      },
    },
    id: "2973624649",
    item_id: "2973624649",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "10",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "plastic, electronic, battery",
        title: "Salvage",
      },
      {
        text: "optical mouse",
        title: "Description",
      },
      {
        text: "",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Cups",
    converts_to: ["plastic"],
    poss_converts_to: ["plastic"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973624896_v_0",
    pixiData: {
      position: {
        x: 600,
        y: 200,
      },
    },
    id: "2973624896",
    item_id: "2973624896",
    column_values: [
      {
        text: "2022-09-04",
        title: "Last Use Date",
      },
      {
        text: "80",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "plastic",
        title: "Salvage",
      },
      {
        text: "Multicolor plastic cups",
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587404390/cups.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
];


export let boardData2 = {
  "name": "New Board",
  "id": "2947296089",
  "items": [
    {
      "name": "Chairs",
      "id": "2947296123",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": "Working on it"
        },
        {
          "title": "Last Use Date",
          "text": "2022-07-19"
        },
        {
          "title": "Quantity",
          "text": "20"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "wood, steel"
        }
      ]
    },
    {
      "name": "Desk",
      "id": "2947296133",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": "Done"
        },
        {
          "title": "Last Use Date",
          "text": "2022-07-12"
        },
        {
          "title": "Quantity",
          "text": "12"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "wood, plastic, boards"
        }
      ]
    },
    {
      "name": "Paper",
      "id": "2973623318",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "600"
        },
        {
          "title": "Units",
          "text": "sheets"
        },
        {
          "title": "Materials",
          "text": "paper, cardboard"
        }
      ]
    },
    {
      "name": "Computer Monitor",
      "id": "2973623523",
      "column_values": [
        {
          "title": "Person",
          "text": ""
        },
        {
          "title": "Status",
          "text": null
        },
        {
          "title": "Last Use Date",
          "text": ""
        },
        {
          "title": "Quantity",
          "text": "16"
        },
        {
          "title": "Units",
          "text": "pcs"
        },
        {
          "title": "Materials",
          "text": "plastic, electronic, screen"
        }
      ]
    },
  ]
};

export let fb_items2 = [
  {
    name: "Chairs",
    converts_to: ["wood"],
    poss_converts_to: ["wood", "steel"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2947296123_v_0",
    pixiData: {
      position: {
        x: 400,
        y: 100,
      },
    },
    id: "2947296123",
    item_id: "2947296123",
    column_values: [
      {
        text: "2022-09-30",
        title: "Last Use Date",
      },
      {
        text: "20",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "wood, steel",
        title: "Salvage",
      },
      {
        text: "Steel case karman plastic chairs",
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587402636/chair.jpeg",
        title: "Photos",
      },
    ],
    ndId: "2947296123",
    ndType: "board_item",
  },
  {
    name: "Desk",
    converts_to: ["wood"],
    poss_converts_to: ["wood", "plastic", "boards", "board"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2947296133_v_0",
    pixiData: {
      position: {
        x: 300,
        y: 300,
      },
    },
    id: "2947296133",
    item_id: "2947296133",
    column_values: [
      {
        text: "2022-09-30",
        title: "Last Use Date",
      },
      {
        text: "12",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "wood, plastic, boards",
        title: "Salvage",
      },
      {
        text: '48" x 24" wooden desks',
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587402655/desk.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Paper",
    converts_to: ["paper"],
    poss_converts_to: ["paper", "cardboard"],
    ingredients: [],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: [],
    poss_tags: [],
    entityId: "b_2947296089_i_2973623318_v_0",
    pixiData: {
      position: {
        x: 400,
        y: 700,
      },
    },
    id: "2973623318",
    item_id: "2973623318",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "600",
        title: "Quantity",
      },
      {
        text: "sheets",
        title: "Units",
      },
      {
        text: "paper, cardboard",
        title: "Salvage",
      },
      {
        text: "A4 sized used and unused",
        title: "Description",
      },
      {
        text: "",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
  {
    name: "Computer Monitor",
    converts_to: ["plastic", "circuitboard"],
    poss_converts_to: ["plastic", "electronic", "screen"],
    ingredients: ["plastic", "circuitboard", "screen"],
    poss_ingredients: [],
    converts_from: [],
    poss_converts_from: [],
    tags: ["ewaste", "electronic", "display", "screen", "computer"],
    poss_tags: [],
    entityId: "b_2947296089_i_2973623523_v_0",
    pixiData: {
      position: {
        x: 600,
        y: 500,
      },
    },
    id: "2973623523",
    item_id: "2973623523",
    column_values: [
      {
        text: "2022-09-11",
        title: "Last Use Date",
      },
      {
        text: "16",
        title: "Quantity",
      },
      {
        text: "pcs",
        title: "Units",
      },
      {
        text: "plastic, electronic, screen",
        title: "Salvage",
      },
      {
        text: '27" LCD Screens',
        title: "Description",
      },
      {
        text: "https://amitlzkpa.monday.com/protected_static/6632627/resources/587403221/computer-monitor.jpg",
        title: "Photos",
      },
    ],
    ndId: "",
    ndType: "board_item",
  },
];





export let boardData_multi = [boardData, boardData2];

export let fb_items_multi = [...fb_items, ...fb_items2];


